import { keyBy, sortBy } from "lodash";

import FiftyFirstState from "url:./51st-state.md";
import AllInPredictions from "url:./all-in-predictions.md";
import Atiwa from "url:./atiwa.md";
import Bacon from "url:./bacon.md";
import CafeBaras from "url:./cafe-baras.md";
import Calico from "url:./calico.md";
import CaptainSonar from "url:./captain-sonar.md";
import Cartographers from "url:./cartographers.md";
import CastlesOfBurgundy from "url:./castles-of-burgundy.md";
import ClankInSpace from "url:./clank-in-space.md";
import ColtExpress from "url:./colt-express.md";
import CosmicEncounter from "url:./cosmic-encounter.md";
import CritterKitchen from "url:./critter-kitchen.md";
import Cryptid from "url:./cryptid.md";
import DeadOfWinter from "url:./dead-of-winter.md";
import DeadlyDowagers from "url:./deadly-dowagers.md";
import DevilsDice from "url:./devils-dice.md";
import DisneyVillainous from "url:./disney-villainous.md";
import Downforce from "url:./downforce.md";
import DraculasFeast from "url:./draculas-feast.md";
import DreadfulMeadows from "url:./dreadful-meadows.md";
import Emberheart from "url:./emberheart.md";
import FalloutShelter from "url:./fallout-shelter.md";
import Flamecraft from "url:./flamecraft.md";
import ForbiddenIsland from "url:./forbidden-island.md";
import ForgottenWaters from "url:./forgotten-waters.md";
import Formaggio from "url:./formaggio.md";
import FormulaD from "url:./formula-d.md";
import FrenchToast from "url:./french-toast.md";
import Fromage from "url:./fromage.md";
import GalaxyTrucker from "url:./galaxy-trucker.md";
import Gutenberg from "url:./gutenberg.md";
import GirlsVsGhouls from "url:./girls-vs-ghouls.md";
import Hardback from "url:./hardback.md";
import Hearts from "url:./hearts.md";
import HoneyBuzz from "url:./honey-buzz.md";
import LetsGoToJapan from "url:./lets-go-to-japan.md";
import LetterJam from "url:./letter-jam.md";
import LibertaliaWindsOfGalecrest from "url:./libertalia-winds-of-galecrest.md";
import LordsOfWaterdeep from "url:./lords-of-waterdeep.md";
import LostRuinsOfArnak from "url:./lost-ruins-of-arnak.md";
import ManhattanProject from "url:./manhattan-project.md";
import Mariposas from "url:./mariposas.md";
import MarvelChampions from "url:./marvel-champions.md";
import NyctophobiaVampire from "url:./nyctophobia-vampire.md";
import OffWithTheirHeads from "url:./off-with-their-heads.md";
import Paperback from "url:./paperback.md";
import PhantomInkArcana from "url:./phantom-ink-arcana.md";
import Pollen from "url:./pollen.md";
import RicochetRobots from "url:./ricochet-robots.md";
import RobinsonCrusoe from "url:./robinson-crusoe.md";
import Rum from "url:./rum.md";
import Sail from "url:./sail.md";
import SanJuan from "url:./san-juan.md";
import Sandbag from "url:./sandbag.md";
import ShadowsOverCamelot from "url:./shadows-over-camelot.md";
import SilverAndGold from "url:./silver-and-gold.md";
import StardewValley from "url:./stardew-valley.md";
import SteamPark from "url:./steam-park.md";
import SurfosaurusMax from "url:./surfosaurus-max.md";
import Targi from "url:./targi.md";
import TeaWitches from "url:./tea-witches.md";
import TheFoxExperiment from "url:./the-fox-experiment.md";
import TheGrimmMasquerade from "url:./the-grimm-masquerade.md";
import TheShipwreckArcana from "url:./the-shipwreck-arcana.md";
import ToyBattle from "url:./toy-battle.md";
import TragedyLooper from "url:./tragedy-looper.md";
import TuringMachine from "url:./turing-machine.md";
import Tzolkin from "url:./tzolkin.md";
import Vagrantsong from "url:./vagrantsong.md";
import Vantage from "url:./vantage.md";
import Vivo from "url:./vivo.md";
import Voyages from "url:./voyages.md";
import Waypoints from "url:./waypoints.md";
import WesternLegends from "url:./western-legends.md";

export interface TeachInfo {
  teachId: string;
  title: string;
  notes: string;
}

export const TEACHES: TeachInfo[] = sortBy(
  [
    {
      teachId: "51st-state",
      title: "51st State",
      notes: FiftyFirstState,
    },
    {
      teachId: "all-in-predictions",
      title: "All In: Predictions",
      notes: AllInPredictions,
    },
    {
      teachId: "atiwa",
      title: "Atiwa",
      notes: Atiwa,
    },
    {
      teachId: "bacon",
      title: "Bacon",
      notes: Bacon,
    },
    {
      teachId: "cafe-baras",
      title: "Café Baras",
      notes: CafeBaras,
    },
    {
      teachId: "calico",
      title: "Calico",
      notes: Calico,
    },
    {
      teachId: "captain-sonar",
      title: "Captain Sonar",
      notes: CaptainSonar,
    },
    {
      teachId: "cartographers",
      title: "Cartographers",
      notes: Cartographers,
    },
    {
      teachId: "castles-of-burgundy",
      title: "Castles of Burgundy",
      notes: CastlesOfBurgundy,
    },
    {
      teachId: "clank-in-space",
      title: "Clank! In! Space!",
      notes: ClankInSpace,
    },
    {
      teachId: "colt-express",
      title: "Colt Express",
      notes: ColtExpress,
    },
    {
      teachId: "cosmic-encounter",
      title: "Cosmic Encounter",
      notes: CosmicEncounter,
    },
    {
      teachId: "critter-kitchen",
      title: "Critter Kitchen",
      notes: CritterKitchen,
    },
    {
      teachId: "cryptid",
      title: "Cryptid",
      notes: Cryptid,
    },
    {
      teachId: "dead-of-winter",
      title: "Dead of Winter: A Crossroads Game",
      notes: DeadOfWinter,
    },
    {
      teachId: "deadly-dowagers",
      title: "Deadly Dowagers",
      notes: DeadlyDowagers,
    },
    {
      teachId: "devils-dice",
      title: "Devil's Dice",
      notes: DevilsDice,
    },
    {
      teachId: "disney-villainous",
      title: "Disney Villainous",
      notes: DisneyVillainous,
    },
    {
      teachId: "downforce",
      title: "Downforce",
      notes: Downforce,
    },
    {
      teachId: "draculas-feast",
      title: "Dracula's Feast",
      notes: DraculasFeast,
    },
    {
      teachId: "dreadful-meadows",
      title: "Dreadful Meadows",
      notes: DreadfulMeadows,
    },
    {
      teachId: "emberheart",
      title: "Emberheart",
      notes: Emberheart,
    },
    {
      teachId: "fallout-shelter",
      title: "Fallout Shelter",
      notes: FalloutShelter,
    },
    {
      teachId: "flamecraft",
      title: "Flamecraft",
      notes: Flamecraft,
    },
    {
      teachId: "forbidden-island",
      title: "Forbidden Island",
      notes: ForbiddenIsland,
    },
    {
      teachId: "forgotten-waters",
      title: "Forgotten Waters",
      notes: ForgottenWaters,
    },
    {
      teachId: "formaggio",
      title: "Formaggio",
      notes: Formaggio,
    },
    {
      teachId: "formula-d",
      title: "Formula D",
      notes: FormulaD,
    },
    {
      teachId: "french-toast",
      title: "French Toast",
      notes: FrenchToast,
    },
    {
      teachId: "fromage",
      title: "Fromage",
      notes: Fromage,
    },
    {
      teachId: "galaxy-trucker",
      title: "Galaxy Trucker",
      notes: GalaxyTrucker,
    },
    {
      teachId: "gutenberg",
      title: "Gutenberg",
      notes: Gutenberg,
    },
    {
      teachId: "girls-vs-ghouls",
      title: "Girls vs Ghouls",
      notes: GirlsVsGhouls,
    },
    {
      teachId: "hardback",
      title: "Hardback",
      notes: Hardback,
    },
    {
      teachId: "hearts",
      title: "Hearts",
      notes: Hearts,
    },
    {
      teachId: "honey-buzz",
      title: "Honey Buzz",
      notes: HoneyBuzz,
    },
    {
      teachId: "lets-go-to-japan",
      title: "Let's Go! To Japan",
      notes: LetsGoToJapan,
    },
    {
      teachId: "letter-jam",
      title: "Letter Jam",
      notes: LetterJam,
    },
    {
      teachId: "liberalia-winds-of-galecrest",
      title: "Libertalia: Winds of Galecrest",
      notes: LibertaliaWindsOfGalecrest,
    },
    {
      teachId: "lords-of-waterdeep",
      title: "Lords of Waterdeep",
      notes: LordsOfWaterdeep,
    },
    {
      teachId: "lost-ruins-of-arnak",
      title: "Lost Ruins of Arnak",
      notes: LostRuinsOfArnak,
    },
    {
      teachId: "manhattan-project",
      title: "Manhattan Project",
      notes: ManhattanProject,
    },
    {
      teachId: "mariposas",
      title: "Mariposas",
      notes: Mariposas,
    },
    {
      teachId: "marvel-champions",
      title: "Marvel Champions",
      notes: MarvelChampions,
    },
    {
      teachId: "nyctophobia-vampire",
      title: "Nyctophobia: Vampire Encounter",
      notes: NyctophobiaVampire,
    },
    {
      teachId: "off-with-their-heads",
      title: "Off With Their Heads!",
      notes: OffWithTheirHeads,
    },
    {
      teachId: "paperback",
      title: "Paperback",
      notes: Paperback,
    },
    {
      teachId: "phantom-ink-arcana",
      title: "Phantom Ink: Arcana",
      notes: PhantomInkArcana,
    },
    {
      teachId: "pollen",
      title: "Pollen",
      notes: Pollen,
    },
    {
      teachId: "ricochet-robots",
      title: "Ricochet Robots",
      notes: RicochetRobots,
    },
    {
      teachId: "robinson-crusoe",
      title: "Robinson Crusoe: Adventures on the Cursed Island",
      notes: RobinsonCrusoe,
    },
    {
      teachId: "rum",
      title: "RUM",
      notes: Rum,
    },
    {
      teachId: "sail",
      title: "Sail",
      notes: Sail,
    },
    {
      teachId: "san-juan",
      title: "San Juan",
      notes: SanJuan,
    },
    {
      teachId: "sandbag",
      title: "Sandbag",
      notes: Sandbag,
    },
    {
      teachId: "shadows-over-camelot",
      title: "Shadows over Camelot",
      notes: ShadowsOverCamelot,
    },
    {
      teachId: "silver-and-gold",
      title: "Silver & Gold",
      notes: SilverAndGold,
    },
    {
      teachId: "stardew-valley",
      title: "Stardew Valley: The Board Game",
      notes: StardewValley,
    },
    {
      teachId: "steam-park",
      title: "Steam Park",
      notes: SteamPark,
    },
    {
      teachId: "surfosaurus-max",
      title: "Surfosaurus Max",
      notes: SurfosaurusMax,
    },
    {
      teachId: "targi",
      title: "Targi",
      notes: Targi,
    },
    {
      teachId: "tea-witches",
      title: "Tea Witches",
      notes: TeaWitches,
    },
    {
      teachId: "the-fox-experiment",
      title: "The Fox Experiment",
      notes: TheFoxExperiment,
    },
    {
      teachId: "the-grimm-masquerade",
      title: "The Grimm Masquerade",
      notes: TheGrimmMasquerade,
    },
    {
      teachId: "the-shipwreck-arcana",
      title: "The Shipwreck Arcana",
      notes: TheShipwreckArcana,
    },
    {
      teachId: "toy-battle",
      title: "Toy Battle",
      notes: ToyBattle,
    },
    {
      teachId: "tragedy-looper",
      title: "Tragedy Looper",
      notes: TragedyLooper,
    },
    {
      teachId: "turing-machine",
      title: "Turing Machine",
      notes: TuringMachine,
    },
    {
      teachId: "tzolkin",
      title: "Tzolk'in: The Mayan Calendar",
      notes: Tzolkin,
    },
    {
      teachId: "vagrantsong",
      title: "Vagrantsong",
      notes: Vagrantsong,
    },
    {
      teachId: "vantage",
      title: "Vantage",
      notes: Vantage,
    },
    {
      teachId: "vivo",
      title: "Vivo",
      notes: Vivo,
    },
    {
      teachId: "voyages",
      title: "Voyages",
      notes: Voyages,
    },
    {
      teachId: "waypoints",
      title: "Waypoints",
      notes: Waypoints,
    },
    {
      teachId: "western-legends",
      title: "Western Legends",
      notes: WesternLegends,
    },
  ],
  "title",
);
export const TEACH_BY_ID = keyBy(TEACHES, "teachId");
